import { ClientConfigProductName } from '@frontend/vanilla/core';

export const MinigamesLoader = {
    id: 'minigames',
    loaderFn: () => import(/* webpackChunkName: "ms-minigames-widget" */ './minigames.feature'),
    product: ClientConfigProductName.SPORTS,
};
